// extracted by mini-css-extract-plugin
export default {"col":"QuestionSeven_col__7k1CX","infobox":"QuestionSeven_infobox__waYwl"};